import createPersistedState from "vuex-persistedstate";

import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const Store = {
    plugins: [createPersistedState()],
    state,
    mutations,
    actions,
    getters
};

export default Store;
